<script>
import axios from 'axios';

export default {
    props: {
        placeholder: String,
        success: String,
        error: String,
    },
    data() {
        return {
            axiosUrl: '/wp-json/kva/newsletter',
            axiosParams: {
                email: ''
            },
            email: '',
            output: '',
            disabled: false
        };
    },
    methods: {
        formSubmit(e) {
            e.preventDefault();
            const currentObj = this;

            axios
                .post(this.axiosUrl, this.axiosParams)
                .then((response) => {
                    if (response.status == 200) {
                        currentObj.output = this.success;
                        this.disabled = true;
                    } else {
                        currentObj.output = this.error;
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        reset() {
            this.disabled = false;
            this.output = '';
        }
    },
};
</script>

<template>
    <form class="form" @submit="formSubmit">
        <input class="form__field" type="email" required :placeholder="placeholder" v-model="axiosParams.email"
            @keydown="reset" />
        <button :disabled="disabled" class="button button--submit"><span class="sr-only">Submit</span></button>
    </form>
    <span>{{ output }}</span>
</template>

<style scoped>
form {
    display: flex;
    margin-top: 8px;
}

input {
    width: 100%;
    max-width: 250px;
}

button {
    margin-left: 16px;
}

span {
    display: inline-block;
    margin-top: 8px;
    font-size: 1.4rem;
}
</style>
